import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/dislike.svg';

export const IconDislike = createIconComponent(Icon);
